import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import './infoTooltipComponent.css';

// Small info icon showing explanatory text on hover and keyboard focus.
// The text arrives pre-translated from the caller.
const InfoTooltipComponent = ({ text }) => (
    <OverlayTrigger overlay={<Tooltip id="info-tooltip">{text}</Tooltip>}>
        <span tabIndex={0} aria-label={text} className="info-tooltip">
            <FontAwesomeIcon icon={faInfoCircle} size="sm" />
        </span>
    </OverlayTrigger>
);

export default InfoTooltipComponent;
